export default __webpack_public_path__ + "static/media/ProAgric.88d30238.jpg";